import { Component, OnInit, ViewChildren, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { isPlatformBrowser } from '@angular/common';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-phone-verification',
  templateUrl: './phone-verification.component.html',
  styleUrls: ['./phone-verification.component.css']
})
export class PhoneVerificationComponent implements OnInit {

  form: FormGroup

  seoData: SeoSocialShareData = {
    title:  'Verify Phone',
    description: 'Please verify the phone number to make sure it is you.',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private _route: ActivatedRoute, private router: Router, private authService: AuthService, private _notification: MatSnackBar,  @Inject(PLATFORM_ID) protected platformId: Object,
   private seo: SeoSocialShareService) {
    this.form = this.toFormGroup(this.formInput)
  }

  accessToken: string

  formInput = ['input1', 'input2', 'input3', 'input4'];
  
  @ViewChildren('formRow') rows: any;

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this._route.queryParams
      .subscribe(params => {
        if(params.token) {
          this.accessToken = params.token
          if(params.sendAgain){
            this.sendOTP()
          }
        }else{
          this.router.navigate(['/login'])
        }
      });
  }

  toFormGroup(elements) {
    const group: any = {};
    elements.forEach(key => {
      group[key] = new FormControl('', Validators.required);
    });
    return new FormGroup(group);
   }

  verifyUser(code){
    this.authService.verifyUserPhone(this.accessToken, code).subscribe(data => {
      if(data.status){
        this.openNotification('You are verified successfully! Please login to continue.')	
        this.router.navigate(['/login']);	
      }
    }, error => {
      if(error.error){
        if(error.error.msg){
          this.openNotification(error.error.msg);
        }else if(error.error.message){
          this.openNotification(error.error.message);
        }
      }
    })
  }

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  goToNextInput(event, index){
    if(isPlatformBrowser(this.platformId)){
      var value = event.target.value
      let pos = index;
      if (event.keyCode === 8 && event.which === 8) {
        pos = index - 1 ;
      }else {
        if(!isNaN(value)){
          if(Number.isInteger(parseInt(value))){
            pos = index + 1 ;
          }
        }else{
          event.preventDefault()
        }
      }
      if (pos > -1 && pos < this.formInput.length ) {
        this.rows._results[pos].nativeElement.focus();
      }
    }  
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  onSubmit() {
    var values = this.form.value
    var code = ''
    for(let key in values){
      code = code + values[key]
    }
    this.verifyUser(code)
  }

  sendOTP(){
    this.authService.sendOTP(this.accessToken).subscribe(data => {
      if(data.status){
        this.openNotification(data.message)
      }
    })
  }

}
